import { useAppScopeStore, useScopedAppFlagStore } from '@frontend/scope';
import { hasAccess } from '../utils/has-access';

/**
 * Determines if the user has access to the Brand Settings feature.
 *
 * To have access, the following conditions must be met:
 * 1. The user has the BRAND_SETTINGS_MANAGE permission for one or more selected locations
 * 2. The 'brand-settings' feature flag is enabled according to the passed getFeatureFlag function
 *
 * @returns An object containing the access status
 * @returns {boolean} hasAccess - True if the user has access to Brand Settings, false otherwise
 */
export const useHasAccess = () => {
  const { selectedLocationIds } = useAppScopeStore();
  const { getFeatureFlagValue } = useScopedAppFlagStore();
  return { hasAccess: hasAccess(selectedLocationIds, getFeatureFlagValue) };
};
